'use client'

import { installClientConsoleGate } from '@/lib/install-client-console-gate'

// Install synchronously on client module load so early API middleware
// cannot dump console.log before useEffect runs.
if (typeof window !== 'undefined') {
  installClientConsoleGate()
}

/** Marks that the console gate module is loaded (side effect above does the work). */
export function ClientConsoleGate() {
  return null
}
